import React from 'react';
const points = [{
  num: '01',
  title: 'Sunday Afternoon Anxiety.',
  desc: "You can't enjoy your BBQ because you're stressing over what routine to teach on Monday morning."
}, {
  num: '02',
  title: 'The Work Never Ends.',
  desc: "You spend hours correcting posture in class, then come home to the mental load of prepping the next day's flow."
}, {
  num: '03',
  title: 'Plateauing Students.',
  desc: 'You feel you lack the technical tools to help your clients break through to the next level of strength and flexibility.'
}, {
  num: '04',
  title: 'Chasing Excellence.',
  desc: 'You want to be the premium instructor who delivers a gold-standard, modern program every single time.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-main py-20 px-4 relative overflow-hidden" data-id="element-97">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[80px] pointer-events-none" data-id="element-98"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-99">
        <div className="text-center mb-12" data-id="element-100">
          <span className="text-4xl mb-4 block" data-id="element-101">👀</span>
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4 tracking-tight" data-id="element-102">
            Do you recognise yourself in these scenes?
          </h2>
          <p className="text-text-sec text-lg" data-id="element-103">
            The Pilates Pack is for you if you're living these situations:
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-104">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-white rounded-2xl p-6 border border-border-light hover:border-primary/30 transition-colors group shadow-[0_4px_15px_rgba(201,137,155,0.04)]" data-id="element-105">
              <div className="w-10 h-10 rounded-full bg-bg-alt flex items-center justify-center flex-shrink-0 border border-border-light group-hover:bg-primary/10 transition-colors" data-id="element-106">
                <span className="text-primary font-bold text-sm" data-id="element-107">
                  {point.num}
                </span>
              </div>
              <div data-id="element-108">
                <h3 className="text-text-main text-lg font-bold mb-1" data-id="element-109">
                  {point.title}
                </h3>
                <p className="text-text-sec leading-relaxed" data-id="element-110">{point.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center bg-primary/10 border border-primary/20 rounded-2xl p-6 sm:p-8" data-id="element-111">
          <p className="text-text-main text-xl font-bold" data-id="element-112">
            ✋ Sound like you? Then this Vault is the mentor you've been looking
            for.
          </p>
        </div>
      </div>
    </section>;
}